import Image from 'next/image';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import H1 from '@/components/base/Headings/H1';

import jellyco_purple from '../../../../../../public/images/giveaway-picker/Jellycos/jellyco_purple.png';

const CheckEmail = () => {
    const { t } = useTranslation('giveaway_picker');
    return (
        <div
            className="mx-auto mb-14 flex h-full max-w-150 flex-col items-center justify-center gap-10"
            data-testid="check-email">
            <div
                className="flex w-[440px] items-center justify-center p-8"
                style={{
                    background: 'linear-gradient(90deg, #FFF 0%, #F6F8FB 50.08%, #FFF 100%)'
                }}>
                <Image src={jellyco_purple} alt="jellyco_purple" width={80} height={80} />
            </div>
            <div className="flex flex-col items-center gap-10 text-center">
                <H1>{t('draw_in_progress.check_email.title')}</H1>
                <p className="font-GMedium text-xl text-icoGray-500">
                    {t('draw_in_progress.check_email.description')}
                </p>
            </div>
        </div>
    );
};

export default CheckEmail;
